import React, { FC, useLayoutEffect } from "react";
import { NewsletterConfirmationModel } from "./models/NewsletterConfirmation.model";
import { NewsletterConfirmationProps } from "./types/NewsletterConfirmation.types";
import { RichText } from "@sitecore-jss/sitecore-jss-react";

import "./style.scss";

const NewsletterConfirmation: FC<NewsletterConfirmationProps> = (props) => {
  const model = new NewsletterConfirmationModel(props);

  useLayoutEffect(() => {
    window?.scroll(0, 0);
  }, []);

  return (
    <section className="newsletter-Confirmation" id={props?.rendering?.uid}>
      <div className="newsletter-Confirmation__container">
        <div className="newsletter-Confirmation__title">
          <RichText
            field={model.title}
            className="ColumnCard__eyebrow-text"
            tag="h1"
          />
        </div>
        <RichText
          field={model.description}
          tag="div"
          className="newsletter-Confirmation__info"
        />
      </div>
    </section>
  );
};

export default NewsletterConfirmation;
